export enum CardType {
  ENCRYPTED = '1',
  INDEX = '2',
  PLAIN = '3',
  MASKED = '4',
}
